import { WhatsappIcon } from 'components/modulab/Icon';
import React from 'react';

interface WhatsAppButtonBaseProps {
  text?: string;
  iconSize?: number;
}

interface WhatsAppButtonLinkProps extends WhatsAppButtonBaseProps {
  type: 'link';
  href: string;
}

interface WhatsAppButtonProps extends WhatsAppButtonBaseProps {
  type: 'button';
  onClick: () => void;
}

type ComponentProps = WhatsAppButtonLinkProps | WhatsAppButtonProps;

export const WhatsAppButton: React.FC<ComponentProps> = (props) => {
  const styles =
    'bg-[#25D366] rounded-xl flex items-center text-white gap-2 justify-center size-full';

  if (props.type === 'link') {
    return (
      <a href={props.href} className={styles}>
        <WhatsappIcon color="#ffffff" size={22} />
        {props.text}
      </a>
    );
  }

  return (
    <button type="button" onClick={props.onClick} className={styles}>
      <WhatsappIcon color="#ffffff" size={props.iconSize ?? 28} />
      {props.text}
    </button>
  );
};
